import React from 'react';
import { CheckIcon, CreditCardIcon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CHECKOUT_URL, packageItems, PRODUCT_IMAGE } from '../data/landing';
export function PricingSection() {
  return <section id="pricing" className="bg-ink-mist px-5 py-20" data-id="element-125" data-mp="1egnty3r1a8yc">
      <div className="mx-auto max-w-xl text-center" data-id="element-126" data-mp="1j9gu0ebk4t43">
        <p className="inline-block bg-ink px-4 py-2 text-xs font-bold uppercase tracking-widest text-white" data-id="element-127" data-mp="1jb1qwalcgo54">
          Limited-time offer
        </p>
        <h2 className="mt-5 font-display text-4xl font-bold uppercase leading-none text-ink sm:text-5xl" data-id="element-128" data-mp="1s8u6zgyw3ztk">
          Everything you need to plan your season —{' '}
          <span className="text-gold-dark" data-id="element-129" data-mp="1x6vnbu4xll1c">one simple payment.</span>
        </h2>
        <article className="mt-10 overflow-hidden border border-gold-dark/20 bg-white text-center shadow-xl" data-id="element-130" data-mp="225qjdxrwt63e">
          <header className="border-t-4 border-gold bg-ink px-6 py-7" data-id="element-131" data-mp="2x1tp7dvvclk">
            <h3 className="font-display text-3xl font-bold uppercase text-white" data-id="element-132" data-mp="7ubqj83lqqjf">
              TENNIS READY™ — Complete Package
            </h3>
            <p className="mt-2 text-sm font-semibold text-gold" data-id="element-133" data-mp="1hq81jrxuzpyi">
              6 Volumes + 5 Strategic Bonuses
            </p>
          </header>
          <div className="p-7 sm:p-10" data-id="element-134" data-mp="1crmx1gbkqk49">
            <img src={PRODUCT_IMAGE} alt="TENNIS READY complete coaching package" width={1536} height={1024} loading="lazy" className="mx-auto -mt-3 mb-5 w-full max-w-md object-contain" data-id="element-135" data-mp="17rs99ln3ianf" />
            <div id="offer-details" className="mb-8 scroll-mt-3 border-y border-gold-dark/20 py-7" data-id="element-136" data-mp="20ecx4c4d44m8">
              <p className="mb-5 text-xs font-bold uppercase tracking-widest text-ink" data-id="element-137" data-mp="1rgauxt8w75xd">
                What's included
              </p>
              <ul className="grid gap-3 text-left sm:grid-cols-2" data-id="element-138" data-mp="k3r2oi9h94an">
                {packageItems.map(item => <li key={item} className="flex items-center gap-2 text-sm font-semibold text-ink" data-id="element-139" data-mp="g2p6696y36cd">
                    <span className="grid h-5 w-5 shrink-0 place-items-center rounded-full bg-gold-sand" data-id="element-140" data-mp="mftcpknbr0zo">
                      <CheckIcon className="h-3.5 w-3.5 text-gold-dark" data-id="element-141" data-mp="7isjtdteczzm" />
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="mt-7" data-id="element-142" data-mp="3uvwbf0wglfbv">
              <p className="text-sm font-semibold text-slate-600" data-id="element-143" data-mp="3uutgmhw0msqo">
                Total value: <s data-id="element-144" data-mp="3jbd6h28hwsv">$90 USD</s>
              </p>
              <div className="mt-1 flex items-baseline justify-center text-ink" data-id="element-145" data-mp="3kz08dapbxlep">
                <span className="font-display text-5xl font-bold" data-id="element-146" data-mp="3pxl1kq65z4tn">$</span>
                <strong className="font-display text-8xl font-bold leading-none tracking-tight" data-id="element-147" data-mp="3pvgxa74cs3su">
                  27
                </strong>
                <span className="ml-2 text-sm font-bold text-slate-600" data-id="element-148" data-mp="3fzx1rltpb74m">
                  USD
                </span>
              </div>
              <div className="mt-3 flex flex-wrap justify-center gap-3" data-id="element-149" data-mp="2xbmv8f9lj9vy">
                <span className="bg-gold-dark px-3 py-1.5 text-xs font-bold uppercase tracking-widest text-white" data-id="element-150" data-mp="2sd1vsi264u8k">
                  Save $63
                </span>
                <span className="py-1.5 text-xs font-bold uppercase tracking-widest text-slate-600" data-id="element-151" data-mp="31con2b16ojnw">
                  One-time payment
                </span>
                <span className="py-1.5 text-xs font-bold uppercase tracking-widest text-slate-600" data-id="element-152" data-mp="3g8edcldejiyf">
                  Lifetime access
                </span>
              </div>
            </div>
            <a href={CHECKOUT_URL} className="cta-button -mx-2 mt-6 block w-[calc(100%+1rem)] rounded-2xl px-6 py-6 text-xl font-bold sm:text-2xl" data-id="element-153" data-mp="3p1rda79vvku0">
              GET TENNIS READY™ NOW — ONLY $27 USD
            </a>
            <p className="mt-5 flex items-center justify-center gap-1.5 text-xs font-semibold text-slate-600" data-id="element-154" data-mp="3u1m1g329xwbd">
              <ShieldCheckIcon className="h-4 w-4 text-gold-dark" data-id="element-155" data-mp="hyvwgaw35ano" /> Backed by
              our 7-day money-back guarantee
            </p>
            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 border-t border-gold-dark/20 pt-6 text-xs font-bold text-slate-600" data-id="element-156" data-mp="lxuy9mmisraw">
              <span className="flex gap-1" data-id="element-157" data-mp="vq0oorx4j0nz">
                <LockKeyholeIcon className="h-4 w-4" data-id="element-158" data-mp="vozf6rvram8d" /> Secure payment
              </span>
              <span className="flex gap-1" data-id="element-159" data-mp="3v5xkthc3lzfs">
                <ZapIcon className="h-4 w-4" data-id="element-160" data-mp="30trpxdbij4u" /> Access in 5 min
              </span>
              <span className="flex gap-1" data-id="element-161" data-mp="32wgyf6nc88i">
                <CreditCardIcon className="h-4 w-4" data-id="element-162" data-mp="7zn57pslua50" /> Card · GooglePay ·
                ApplePay
              </span>
            </div>
          </div>
        </article>
        <p className="mt-5 text-xs font-semibold text-slate-600" data-id="element-163" data-mp="1jf22kuoq740n">
          Price shown in USD — you’ll be charged the equivalent in your country’s
          local currency.
        </p>
      </div>
    </section>;
}